import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private apiUrl = 'https://api.moxiaoshuju.com';

  constructor(public http: HttpClient) {
  }

  public code(data: any = {}): Observable<any> {
    return this.http.post(this.apiUrl + '/index/sendCompanyEnterSms', data);
  }

  public saveCompanyEnter(data: any = {}): Observable<any> {
    return this.http.post(this.apiUrl + '/index/saveCompanyEnter', data);
  }
}
